var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateIllustrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 23.9992V27.9992M27.9998 31.9992H28.0098M26.2898 18.8592L17.8198 32.9992C17.6451 33.3017 17.5527 33.6445 17.5518 33.9937C17.5508 34.343 17.6413 34.6864 17.8142 34.9898C17.9871 35.2931 18.2365 35.546 18.5375 35.7231C18.8385 35.9002 19.1806 35.9954 19.5298 35.9992H36.4698C36.819 35.9954 37.1611 35.9002 37.4621 35.7231C37.7631 35.546 38.0124 35.2931 38.1854 34.9898C38.3583 34.6864 38.4488 34.343 38.4478 33.9937C38.4468 33.6445 38.3544 33.3017 38.1798 32.9992L29.7098 18.8592C29.5315 18.5653 29.2805 18.3223 28.981 18.1537C28.6814 17.9851 28.3435 17.8965 27.9998 17.8965C27.656 17.8965 27.3181 17.9851 27.0186 18.1537C26.7191 18.3223 26.468 18.5653 26.2898 18.8592Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateIllustrations);
export default __webpack_public_path__ + "static/media/emptyStateIllustrations.3252c45edccd467b22461d652db13845.svg";
export { ForwardRef as ReactComponent };